import { ProductPromotion } from '../../../products/types';

type rawType = {
  [key: string]: string;
} | null;

export const serializeProductPromotion = (
  props: rawType
): ProductPromotion | null => {
  if (!props?.title || !props.icon) {
    return null;
  }

  return {
    title: props.title,
    icon: props.icon
  } as ProductPromotion;
};
